export enum TargetType {
    None = 0,
    Budget = 1,
    Target = 2,
    MinMax = 3
}
